import { getStoykaName } from "../../helpers/getStoykaName";
import { toggleSceneObject } from "../../togglers";
import { DEFAULT_Y } from "./pos_map";

export const changeStoykiDerzhatelRulona = (isChecked, count) => {
    const stoykaName = getStoykaName();
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const name = `dopolnitelniy_derzhatel_${count}__rulona__stoyka__${stoykaName}__${width}x${depth}`;
    const activeDerzhatel = servObj.activeDerzhatelRulonaStoyka.find((derzhatel) => derzhatel.userData.count === count);
    const visibleChildren = activeDerzhatel?.userData.visibleChildren ?? [];

    toggleSceneObject({
        allObjects: servObj.allDerzhatelRulonaStoyka,
        activeArray: servObj.activeDerzhatelRulonaStoyka,
        name,
        isChecked,
        filterActiveFn: (el) => el.userData.count !== count,
        position: { y: DEFAULT_Y },
        userData: { name, count, width, visibleChildren },
        hideChildrenName: ["bokovoy_fiksator_rulona"],
    });
};
